import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import TopNav from "@/components/TopNav";
import {
  saveVolunteer,
} from "@/data/volunteerFlows";

export default function VolunteerSelect() {
  const navigate = useNavigate();

  const choose = (v) => {
    saveVolunteer(v);
    navigate(`/v/${v}`);
  };

  return (
    <div
      className="min-h-screen flex flex-col bg-[var(--bg-base)]"
      data-testid="volunteer-select-page"
    >
      <TopNav />

      <main className="flex-1 w-full mx-auto max-w-3xl px-4 sm:px-6 pt-10 pb-32 flex flex-col items-center">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="w-full text-center"
        >
          <span
            className="arcade-btn arcade-btn-ghost text-[10px] px-3 py-1.5"
            data-testid="volunteer-select-badge"
          >
            Choose your role
          </span>

          <h1
            className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-tight"
            data-testid="volunteer-select-title"
          >
            Which{" "}
            <span className="relative inline-block">
              <span className="relative z-10">volunteer</span>
              <span
                aria-hidden
                className="absolute -bottom-1 left-0 right-0 h-2.5 bg-[var(--accent)]/70 -rotate-1 rounded-sm z-0"
              />
            </span>{" "}
            are you?
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.4 }}
          className="mt-10 w-full max-w-md"
          data-testid="volunteer-select-build-section"
        >
          <VolunteerCard
            label="Build Team"
            testid="volunteer-card-A"
            onClick={() => choose("A")}
          />
        </motion.div>

        {/* Design Team — routes to the Design Guide */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.28, duration: 0.4 }}
          className="mt-6 w-full max-w-md"
          data-testid="volunteer-select-design-section"
        >
          <VolunteerCard
            label="Design Team"
            testid="volunteer-card-other"
            onClick={() => navigate("/design")}
          />
        </motion.div>
      </main>

      {/* Back-to-checklist bottom nav */}
      <div
        className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 flex items-center gap-6"
        data-testid="volunteer-select-bottom-nav"
      >
        <button
          type="button"
          onClick={() => navigate("/checklist")}
          aria-label="Back to checklist"
          data-testid="volunteer-select-prev-btn"
          className="arcade-btn arcade-btn-icon"
        >
          <ChevronLeft strokeWidth={3} className="h-6 w-6" />
        </button>
      </div>
    </div>
  );
}

function VolunteerCard({ label, testid, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className="arcade-btn w-full justify-between px-6 py-4 text-sm sm:text-base"
    >
      <span>{label}</span>
      <ChevronRight strokeWidth={3} className="h-5 w-5" />
    </button>
  );
}
